import type { QSetSimilarityResultData } from '../../types';

export default function generateSimilarityMatrix(
  data: QSetSimilarityResultData[],
): Record<string, Record<string, number | null>> {
  const results = data;
  const qSets = new Set<string>();

  // Collect all unique QSet codes
  results.forEach(({ qSetACode, qSetBCode }) => {
    qSets.add(qSetACode);
    qSets.add(qSetBCode);
  });

  const qSetArray = Array.from(qSets);
  const matrix: Record<string, Record<string, number | null>> = {};

  // Initialize matrix with zeros
  qSetArray.forEach((qSet) => {
    matrix[qSet] = {};
    qSetArray.forEach((innerQSet) => {
      matrix[qSet][innerQSet] = qSet === innerQSet ? null : 0;
    });
  });

  // Fill in duplication rates
  results.forEach(({ qSetACode, qSetBCode, duplicationRate }) => {
    matrix[qSetACode][qSetBCode] = duplicationRate;
    matrix[qSetBCode][qSetACode] = duplicationRate; // Ensure symmetry
  });

  return matrix;
}
